"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("../../../../../Types");
var React = require("react");
var Components_1 = require("../Components");
function ArvatoRenewCertEvent(locationName, updateCallback, applicationData) {
    var arvatoRenewCertEventContentRef = React.createRef();
    return new Types_1.VeriLiteWarningEvent(React.createElement(Components_1.ArvatoRenewCertEventContent, { ref: arvatoRenewCertEventContentRef, locationName: locationName, updateCallback: updateCallback, applicationData: applicationData }), applicationData.resources.ConfirmCertRenewal_Title, [
        new Types_1.VeriLiteEventAction(applicationData.resources.Yes, "primary", function () {
            var _a;
            (_a = arvatoRenewCertEventContentRef.current) === null || _a === void 0 ? void 0 : _a.renewCert();
        }), new Types_1.VeriLiteEventAction(applicationData.resources.No, "danger", function (currentEvent, closeModalCallback) {
            closeModalCallback();
        })
    ]);
}
exports.ArvatoRenewCertEvent = ArvatoRenewCertEvent;
//# sourceMappingURL=ArvatoRenewCertEvent.js.map